import { useState, useEffect, useCallback } from 'react';
import { getCookie, setCookie } from '../utils/cookies';
import { Language, translations, getDefaultLanguage, Translations } from '../i18n/translations';

interface UseTranslationReturn {
  language: Language;
  setLanguage: (lang: Language) => void;
  t: Translations;
}

export const useTranslation = (cookieConsent: boolean | null): UseTranslationReturn => {
  const [language, setLanguageState] = useState<Language>(getDefaultLanguage());

  // Load language from cookies
  useEffect(() => {
    if (cookieConsent !== true) return;

    const savedLanguage = getCookie('language') as Language | null;
    if (savedLanguage && (savedLanguage === 'en' || savedLanguage === 'pl')) {
      setLanguageState(savedLanguage);
    }
  }, [cookieConsent]);

  // Save language to cookies
  useEffect(() => {
    if (cookieConsent !== true) return;
    setCookie('language', language);
  }, [language, cookieConsent]);

  const setLanguage = useCallback((lang: Language) => {
    setLanguageState(lang);
  }, []);

  return {
    language,
    setLanguage,
    t: translations[language],
  };
};
